// extracted by mini-css-extract-plugin
module.exports = {"exhibitions":"ExhibitionsBig_exhibitions__PvK7b","exhibitionInfo":"ExhibitionsBig_exhibitionInfo__794_u","bottom":"ExhibitionsBig_bottom__ZUYyN"};